<!-- Translated: yes -->
<template>
  <div>
    <CollectorCheckoutConfirmation v-if="SITE_CONFIG.payment_service === 'collector'"></CollectorCheckoutConfirmation>
    <KlarnaCheckoutConfirmation v-else-if="SITE_CONFIG.payment_service === 'klarna'"></KlarnaCheckoutConfirmation>

    <OrderCheckForCancellation></OrderCheckForCancellation>
  </div>
</template>

<script>
import CollectorCheckoutConfirmation from '@/components/payments/CollectorCheckoutConfirmation';
import KlarnaCheckoutConfirmation from '@/components/payments/KlarnaCheckoutConfirmation';
import OrderCheckForCancellation from '@/components/payments/OrderCheckForCancellation';

export default {
  props: {
  },
  components: {
    CollectorCheckoutConfirmation,
    KlarnaCheckoutConfirmation,
    OrderCheckForCancellation,
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
</style>



// WEBPACK FOOTER //
// PaymentServiceCheckoutConfirmationPage.vue?83301006